import React from 'react';
import { useContext, useEffect, useState } from 'react';
import { InfoContext } from "./ApiCenter/AM_BackGroundOP"

const Protected = ({ returnNull=false, admin=[], internal=[], readOnly=[], permissions=[], denyPermissions=[], extraCondition=true, skipPermissions=false, children }) => {
    
    const ctx = useContext(InfoContext);
    const [, setRefresh] = useState(false);
    
    useEffect(() => { 
        const refreshArray = [...new Set([...permissions, ...denyPermissions])];
        if(admin.length > 0) refreshArray.push('admin');
        if(internal.length > 0) refreshArray.push('internal');
        if(readOnly.length > 0) refreshArray.push('readOnly');
        
        const refreshUI = () => setRefresh(p => !p);
        refreshArray.forEach(p => {
            if(!ctx.compRefs.current?.hasOwnProperty(p)) ctx.compRefs.current[p] = new Set();
            ctx.compRefs.current[p].add(refreshUI); 
        })

        return () => {
            refreshArray.forEach(p => {
                ctx.compRefs.current?.[p]?.delete(refreshUI);
            })   
        }
    }, [ctx, admin, internal, permissions, denyPermissions, readOnly])
    
    const notAllowedElement = returnNull ? null : <main className="main" id="main">You are not allowed to access this page.</main>;
    
    if(denyPermissions.length > 0 && denyPermissions.some(p => ctx.userData.current.permissions?.[p])) return notAllowedElement;
    if(skipPermissions) return children;
    
    if (
        (extraCondition) &&
        (admin.length > 0 ? admin.includes(ctx.userData.current.admin) : true) &&
        (internal.length > 0 ? internal.includes(ctx.userData.current.internal) : true) &&
        (readOnly.length > 0 ? readOnly.includes(ctx.userData.current.readOnly) : true) &&
        (permissions.length > 0 ? permissions.some(p => ctx.userData.current.permissions?.[p]) : true)
    ) return children;
    
    return notAllowedElement;
};

export default Protected;
